<template>
    <Modal class="sub-pop" :is_show="is_show_add_modal" @click-bg="close(false)"
        :class="{ 'is-loading': is_loading || is_loading_out }">
        <i class="icon-close" @click="close(false)"><svg-icon name="close" /></i>
        <div :class="['contain', step === 2 && 'p0-24']">
            <label>{{ title }}</label>


            <!-- step1 -->
            <Form :schema="schema" @submit="submit" :values="values" v-slot="{ errors, success }" class="user-form-wrap"
                :class="{ 'is-error': is_error }" ref="form" :key="key_refrash" v-if="step === 1">
                <div class="detail step1">
                    <div class="title">Enter the subdomain name you want to connect</div>
                    <!-- <p>The main domain or sub domain you want creator connect with</p> -->
                    <Field type="text" k="anchor_page_subdomain" placeholder="https://creator.website.com"
                        :default_value="values.anchor_page_subdomain" :error_msg="errors.anchor_page_subdomain"
                        :is_success="success.anchor_page_subdomain" @update="update" :ref="(el) => { els.push(el) }" />

                        
                </div>
                <div class="detail step1" v-if="!pre_redirect_url">
                    <div class="title">Add fallback URL</div>
                    <p>It’s the backup URL, that is used when the traffic cannot reach the main domain for some reasons (filter, cap, if your server is down). Fallback URLs allow you to define alternative URLs for failed network requests.</p>
                    <Field type="text" k="anchor_page_subdomain" placeholder="https://fallback.website.com"
                        :default_value="redirect_url" :error_msg="redirect_url_error"
                        :is_success="redirect_url_success" @update="updateRedirectUrl" :ref="(el) => { els.push(el) }" />
                </div>

                <DomainOl :need_list="false">
                    <template #btn>
                        <div :class="['btn-wrap connect-btn']">
                            <Button type="submit" color="dark-blue" size="32"
                                :border_r="6"
                                :is_disabled="!(values.anchor_page_subdomain && (redirect_url || pre_redirect_url))">Connect</Button>
                        </div>
                    </template>
                </DomainOl>
            </Form>

            <!-- step2 -->
            <Loading v-if="is_loading || is_loading_out" />
            <div class="detail step2" v-if="step === 2 && !is_loading && !is_loading_out">
                <p class="step2-text">{{ step2_text }}</p>

                <div class="host-wrap">
                    <div :class="['value']" v-for="(v, k) in setup_list" :key="k" v-show="k < 3">
                        <label>{{ v.name }}</label>
                        <div class="value-wrap overflow-text" @click="copy(v, k)" 
                        :style="[(k == 0) && `width:${ 649 / 5 }px`, (k == 1 || k == 2) && `width:${649 / 5 * 2}px`,]">
                            <!-- domain_data.value -->
                            <div :class="['overflow-text']">{{ v.value.replace(/^(https?:\/\/)/, '') }}</div>
                            <el-button v-show="k == 1 || k == 2" size="small">Copy</el-button>
                        </div>
                    </div>
                </div>

                <DomainOl :domain_ol="domain_ol" :need_help="false" />
                <DomainCnameBtn :domain_ol="domain_ol" :setup_list="setup_list" @callApi="setSubdomainCheck" />
            </div>

            <!--step3-->
            <div class="step3" v-if="step === 3 || step === 4">
                <div class="detail">
                    <svg-icon name="warning" />
                    <div class="big-title">{{ confirm_edit_contain.top }}</div>
                    <div class="title">{{ confirm_edit_contain.bottom }}</div>


                    <Scrollbar>
                        <div class="list" :key="key_refrash">
                            <span v-for="(v, k) in CreatorStorefront" :key="k"
                                :class="[{ 'green-dot': v.state, 'yellow-dot': !v.state }]">{{ v.url }}</span>
                        </div>
                    </Scrollbar>

                </div>
                <div class="btn-wrap">
                    <el-button type="primary" @click="close(step)">{{ confirm_edit_contain.btn }}</el-button>
                </div>

            </div>
        </div>
    </Modal>
</template>

<script>
import Field from '@/components/ui/Field.vue';
import Form from '@/components/ui/Form.vue';
import Modal from '@/components/ui/Modal.vue';
import DomainOl from '@/components/settings/Domain/DomainOl.vue';
import * as yup from 'yup';
import Scrollbar from '@/components/ui/Scrollbar.vue';
import Loading from '@/components/ui/Loading.vue';
import DomainCnameBtn from '@/components/settings/Domain/DomainCnameBtn.vue';
import copyToClipboard from 'copy-to-clipboard';
import { ElButton } from 'element-plus';
import Button from '@/components/ui/Button.vue';
export default {
    name: 'add-user',

    components: {
        Field,
        Form,
        Modal,
        DomainOl,
        Scrollbar,
        Loading,
        DomainCnameBtn,
        ElButton,
        Button,
    },

    props: {
        data: {
            type: Object,
            default: {
                title: 'Connect subdomain',
            }
        },
        pre_redirect_url: {
            type: String,
            default: ''
        },
        setup_list: {
            type: Array,
            default: []
        },

        domain_ol: {
            type: Array,
            default: []
        },

        sub_url: {
            type: String,
            default: 'www.brand.com'
        },

        is_loading_out: {
            type: Boolean,
            default: false
        },

    },

    data() {
        return {
            //step1->connect
            //step2->DNS Settings
            //step3->Confirm Edit subdomain
            redirect_url: '',
            redirect_url_error: '',
            redirect_url_success: false,
            step: 1,
            is_show_add_modal: false,
            is_loading: false,
            error_msg: '',
            is_error: false,
            els: [],

            values: {
                anchor_page_subdomain: ''
            },
            pattern: /^(https?:\/\/)?([a-zA-Z0-9.-]+)\.[a-zA-Z]{2,}(\/\S*)?$/i,

            schema: yup.object().shape({
                anchor_page_subdomain: yup.string().matches(this.pattern, '*Please use the correct domain format.')
                    .required('Domain cannot be left blank'),
            }),

            CreatorStorefront: [
                {
                    url: 'www.brand.com/creator/1',
                    state: true
                },
                {
                    url: 'www.brand.com/creator/2',
                    state: true
                },
                {
                    url: 'www.brand.com/creator/3',
                    state: false
                },
            ],
            step2_text: `Configure your custom subdomain by adding the below CNAME record using the instructions below.`,
            key_refrash: 0,
        }
    },
    computed: {
        permission_domain(){
            return this.$store.state.user_data?.permission_list?.settingIntegrations?.domainSettings.permission ===100;
        },
        title() {
            let tit = ''
            if (this.step === 1) tit = 'Connect Custom Subdomain';
            if (this.step === 2) tit = 'DNS Settings';
            if (this.step === 3) tit = 'Edit Subdomain';
            if (this.step === 4) tit = 'Disconnect Subdomain';
            return tit;
        },

        confirm_edit_contain() {
            if (this.step === 3) {
                return {
                    top: `You are about to change your custom subdomain.`,
                    bottom: `The URLs of the following pages will be updated once you change this subdomain.  Any links to these pages may no longer work once the change is made.`,
                    btn: `Contact Us`
                }
            } else {
                return {
                    top: `You are about to disconnect your custom subdomain. `,
                    bottom: `The following active pages will redirect to your fallback URL until you have removed the CNAME record in your DNS settings. If you do not have a fallback URL set up, these pages will redirect to the creator's storefront hosted on Motom's domain, when applicable.`,
                    btn: `Disconnect`
                }
            }
        }
    },

    watch: {
        is_staff(val) {
            if (val == 0) {
                this.values.company_name = this.user_company;
            }
        }
    },

    methods: {
        start() {
            //need to check step 1-3
            if (this.step === 1) {
                this.values.anchor_page_subdomain = '';
                setTimeout(() => {
                    this.els.forEach(el => {
                        if (el) el.sync();
                    });

                }, 100);
            } else if (this.step === 3 || this.step === 4) {
                this.CreatorStorefront = [];
                this.$ajax('/settings/get-storefront-urls-under-merchant-account', {
                    method: 'get',
                    withCredentials: true,
                }).then(res => {
                    if (res.data.data.storefronts) {
                        res.data.data.storefronts.forEach(e => {
                            if(e.share_link){
                                this.CreatorStorefront.push({
                                    url: e.share_link.replace(/^(https?:\/\/)+/, 'https://'),
                                    state: e.anchor_page_status_text === 'Active'
                                });
                            }
                        })
                    };
                    this.key_refrash += 1;
                });
            }

        },

        update(obj) {
            this.is_error = false;
            this.error_msg = '';
            Object.keys(this.values).forEach(key => {
                if (key === obj.key) {
                    this.values[key] = obj.val;
                }
            });
        },

        updateRedirectUrl(obj) {
           this.redirect_url = obj.val;
        },

        submit() {
            let redirect_url = '';
            if (!this.pre_redirect_url) {
                redirect_url = this.redirect_url;
            }

            this.$emit('newSubDomain', this.values.anchor_page_subdomain, redirect_url);
            this.step = 2;
            this.setup_list[1].value = this.values.anchor_page_subdomain;
        },

        open(num) {
            this.is_show_add_modal = true;
            this.step = num;
            this.start();

            this.key_refrash += 1;
        },

        close(num) {
            if(num==3){
                let content = `Need to connect a custom subdomain.`;
                const mailtoURL = `mailto:${this.$store.state.mail_to}?subject=${this.$store.state.user_data.merchant_account.merchant_display_name} - Report issue&body=${encodeURIComponent(content)}`;
                window.location.href = mailtoURL;
                // this.$router.replace('/help');
            }
            else if (num === 4) {
                this.$emit('Continue', { step: 1, url: '' });
            };

            this.is_show_add_modal = false;
        },

        setSubdomainCheck() {
            this.$emit('setSubdomainCheck');
            this.close();
        },

        copy(text, k) {
            if (k === 1 || k === 2) {
                copyToClipboard(text.value.replace(/^(https?:\/\/)/, ''), { format: 'text/plain' });
                this.$notify(`<svg><use xlink:href="#yes--sprite"></use></svg> ${text.name} copied`);
            };
        },

        errNofity(err) {
            let mes = err.response && err.response.data.data ? err.response.data.data.message : '';
            this.$notify(`<svg class="err-notify"><use xlink:href="#alert--sprite"></use></svg> Change fail.${mes}`);
        },

    },

    mounted() {
    }

}
</script>
<style lang="scss">
.sub-pop {

    .contain {
        padding-top: 16px;
    }

    label {
        font-size: 36px;
        font-family: var(--font-dm);
    }

    .ui-modal--container {
        background-color: var(--white);
        width: 681px;
        padding: 16px;
    }

    .detail {
        padding: 16px;
    }

    .step1 {
        background-color: var(--bg-02);
        border: none;
        margin: 16px 0;

        .title {
            font-size: 16px;
            margin-bottom: 12px;
        }

        .ui-input {
            margin-top: 4px;
            margin-bottom: 0;
        }
    }

    .step2 {
        padding: 0;
        border: none;

        .step2-text {
            color: var(--black-100);
            margin: 16px 0;
        }

        .host-wrap {
            grid-template-columns: 1fr 2fr 2fr;

            .value {
                &:nth-last-child(2) {
                    .value-wrap {
                        border-right: none;
                    }
                }
            }
        }

    }

    .step3 {
        .detail {
            background-color: var(--light-yellow);
            border: none;
            color: var(--black-90);
            margin: 16px 0;

            .big-title {
                font: var(--font-med-18);
                margin: 12px 0;
            }

            svg {
                width: 30px;
                height: 30px;
                fill: var(--black-75);
            }

            .list {
                height: auto;
                max-height: 30vh;
                margin: 16px 0;

                span {
                    margin-right: 8px;
                    font: var(--font-fg-12);
                    color: var(--black-90);
                    display: flex;
                    align-items: center;
                    margin: 2px 0;
                }
            }

            .title {
                &:after {
                    content: '';
                }
            }
        }
    }

    .btn-wrap {
        float: right;

        &.connect-btn .ui-button {
            padding: 8px 48px;
            height: initial;
            line-height: initial;
        }
    }

    .icon-close {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        svg {
            width: 14px;
            height: 14px;
            fill: var(--dark-blue);
        }
    }

    &.is-loading {
        .user-form-wrap {
            opacity: .5;
            pointer-events: none;

        }
    }


}

.p0-24 {
    padding: 8px 0;
}
</style> 

